<template>
  <div class="main" v-bind:style="{ backgroundImage: 'url(' + dlbj_image + ')' }">
    <!-- 手机扫码登录和账号密码登录 -->
    <div class="loginBox">
      <div v-if="cainiao_logo">
        <img :src="logo_image" />
      </div>
      <div v-if="qnp_logo">
        <img :src="qnp_logo_img" style="height: 65px" />
      </div>
      <!-- <div v-show="!cainiao_logo" class="box_head">菜鸟云仓</div> -->
      <!-- <div v-show="!cainiao_logo" class="box_head">{{ siteName }}</div> -->
      <div v-if="ruyi_logo" class="box_head">
        <img
          :src="ruyi_logo_img"
          style="height: 70px; margin-left: 40px; float: left"
          alt="Logo"
        />
        <!-- <div style="padding: 10px; float: left">{{ siteName }}</div> -->
      </div>
      <div v-if="ty_logo" class="box_head">
        <img
          :src="ty_logo_img"
          style="height: 70px; margin-left: 30px; float: left"
          alt="Logo"
        />
        <div style="margin-top: -56px; margin-left: 110px; float: left">{{ siteName }}</div>
      </div>
      <div class="tabBoxSwitch">
        <ul class="tabBoxSwitchUl">
          <li
            @click="tabSelected = i"
            :class="tabSelected == i ? 'selected' : ''"
            v-for="(v, i) in items"
            :key="i"
          >
            {{ v.title }}
          </li>
        </ul>
      </div>
      <div class="form">
        <ul>
          <!-- 账号登录 -->
          <li v-show="tabSelected == 0">
            <el-form
              :model="accountForm"
              :rules="accountRules"
              ref="accountForm"
              label-width="0px"
            >
              <el-form-item prop="account">
                <el-input
                  v-model="accountForm.account"
                  placeholder="请输入账号"
                  prefix-icon="el-icon-user"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="accountForm.password"
                  placeholder="请输入密码"
                  show-password
                  prefix-icon="el-icon-lock"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="submitForm('accountForm')"
                  type="primary"
                  style="background-color: #0850fc"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </li>
          <!-- 手机登录 -->
          <li v-show="tabSelected == 1">
            <el-form
              :model="phoneForm"
              :rules="phoneRules"
              ref="phoneForm"
              label-width="0px"
            >
              <el-form-item prop="phone">
                <el-input
                  v-model="phoneForm.phone"
                  placeholder="请输入手机号"
                  prefix-icon="el-icon-mobile-phone"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  v-model="phoneForm.code"
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-chat-line-round"
                ></el-input>
                <!-- <a type="button" @click="sendCode">获取验证码</a> -->
                <a type="button" @click="sendCode" :disabled="countdown > 0">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码" }}
                </a>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="submitForm('phoneForm')"
                  type="primary"
                  style="background-color: #0850fc"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </li>
        </ul>
        <!-- <div style="color: #0850fc; padding-top: 15px">注册账号</div> -->
        <div>
          <el-button
            @click="toRegister"
            type="primary"
            style="
              background-color: white;
              color: #0850fc;
              margin-top: 10px;
              padding: 0;
              border: 0px solid white;
              width: 77px;
            "
            >注册账号</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import qs from "qs";
import Cookies from "js-cookie";
import "@/assets/custom-theme/index.css";
Vue.prototype.$qs = qs;

export default {
  name: "login",
  data() {
    return {
      tabSelected: 0,
      items: [{ title: "账号密码登录" }, { title: "验证码登录" }],
      accountForm: {
        account: "",
        password: "",
      },
      phoneForm: {
        phone: "",
        code: "",
      },
      accountRules: {
        account: [{ required: true, message: "请输入邮箱或手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      phoneRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号格式错误", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      logo_image: require("@/assets/cnyc_logo.png"),
      dlbj_image: require("@/assets/dlbj.jpg"),
      countdown: 0, // 倒计时时间
      cainiao_logo: false,
      siteName: "",
      ruyi_logo_img: require("@/assets/ruyi_logo.png"),
      ruyi_logo: false,
      qnp_logo: false,
      ty_logo: false,
      qnp_logo_img: require("@/assets/qnp_logo.png"),
      ty_logo_img: require("@/assets/cnyc_logo2.png"),
    };
  },
  async created() {
    // 获取系统信息并设置logo
    const systemInfo = await this.$root.getSystemInfo();
    if (systemInfo && systemInfo.site_name) {
      this.setLogoBySiteName(systemInfo.site_name);
    }
  },
  methods: {
    setLogoBySiteName(siteName) {
      // 先重置所有logo标志
      this.cainiao_logo = false;
      this.qnp_logo = false;
      this.ruyi_logo = false;
      this.ty_logo = false;
      
      const sn = siteName || Cookies.get("view_site_name");
      if (sn == "菜鸟云仓" || sn == "菜鸟云仓test") {
        this.cainiao_logo = true;
      } else if (sn == "全能拍云仓") {
        this.qnp_logo = true;
      } else if (sn == "如意云仓") {
        this.ruyi_logo = true;
      } else if (sn && sn != "undefined" && sn != "null") {
        this.ty_logo = true;
        this.siteName = sn;
      }
    },
    //登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //alert('验证通过');
          let sendData = {};
          let loginUrl = "";
          const system_id = Cookies.get("view_system_id");
          if (system_id == "" || system_id == null || system_id == undefined) {
            this.$confirm("获取系统信息失败，请刷新重试！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});

            location.reload();
            return;
          }
          if (formName == "accountForm") {
            // 判断是手机号还是邮箱
            sendData = {
              username: this.accountForm.account,
              password: this.accountForm.password,
              system_id: system_id,
            };
            loginUrl = this.$root.commonPreUrl + "/index/indexLogin";
          } else if (formName == "phoneForm") {
            sendData = {
              phone: this.phoneForm.phone,
              code: this.phoneForm.code,
              system_id: system_id,
            };
            loginUrl = this.$root.commonPreUrl + "/index/phoneLogin";
          }
          const res = axios.post(loginUrl, sendData);
          res
            .then((response) => {
              const resd = response.data;
              if (resd.code == 200) {
                const userToken = resd.token;
                Cookies.set("view_userToken", userToken, { expires: 1 });
                // 调用当前用户信息
                // this.$root.getUserInfo();
                // this.$router.push("/");
                const token = Cookies.get("view_userToken");
                const url = this.$root.commonPreUrl + "/index/getUserInfo";
                const res1 = axios.get(url, {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                });
                res1
                  .then((response) => {
                    const resd = response.data;
                    if (resd.code == "200") {
                      const resData = resd.data;
                      Cookies.set("view_userId", resData.id, { expires: 1 });
                      Cookies.set("view_userName", resData.name, { expires: 1 });
                      Cookies.set("view_userBalance", resData.user_balance, {
                        expires: 1,
                      });
                      Cookies.set("view_grade", resData.grade, { expires: 1 });
                      Cookies.set("view_sendName", resData.send_name, { expires: 1 });
                      Cookies.set("view_sendTel", resData.send_tel, { expires: 1 });

                      //代理页面需用
                      Cookies.set("view_url", resData.url, { expires: 1 });
                      Cookies.set("view_code", resData.code, { expires: 1 });
                      Cookies.set("view_yongjin", resData.yongjin, { expires: 1 });

                      // 自动发货页面开关
                      if (resData.switch == 0) {
                        Cookies.set("view_tbwl_auto", 0, { expires: 1 });
                        Cookies.set("view_fhcs_auto", 0, { expires: 1 });
                      } else if (resData.switch == 3) {
                        Cookies.set("view_tbwl_auto", 1, { expires: 1 });
                        Cookies.set("view_fhcs_auto", 1, { expires: 1 });
                      } else if (resData.switch == 2) {
                        Cookies.set("view_tbwl_auto", 1, { expires: 1 });
                        Cookies.set("view_fhcs_auto", 0, { expires: 1 });
                      } else if (resData.switch == 1) {
                        Cookies.set("view_tbwl_auto", 0, { expires: 1 });
                        Cookies.set("view_fhcs_auto", 1, { expires: 1 });
                      }
                      // 手动发货页面的发件人
                      Cookies.set("view_fjr", resData.fjr, { expires: 1 });
                      Cookies.set("justLogin", 'true', { expires: 1/(24*60*20) });
                      this.$router.push("/");
                    } else {
                      this.$confirm(resd.msg, "提示", {
                        confirmButtonText: "确认",
                        showCancelButton: false, //是否显示取消按钮
                      })
                        .then(() => {})
                        .catch(() => {});
                      this.$confirm(resd.msg, "提示", {
                        confirmButtonText: "确认",
                        showCancelButton: false, //是否显示取消按钮
                      })
                        .then(() => {
                          return;
                        })
                        .catch(() => {});
                      this.$router.push("/login");
                      location.reload();
                    }
                    setTimeout(() => {
                      return;
                    }, 1.5 * 1000);
                  })
                  .catch((error) => {
                    console.error("初始请求失败:", error);
                    this.$confirm("登录失败！请检查账号密码是否正确。", "提示", {
                      confirmButtonText: "确认",
                      showCancelButton: false, //是否显示取消按钮
                    })
                      .then(() => {
                        // 重新导航到首页
                        localStorage.clear();
                        this.$root.removeCookies();
                        this.$router.push({ path: "/login" });
                      })
                      .catch(() => {});
                    // location.reload();
                    return;
                  });
              } else {
                // alert("登录失败！原因：" + response.data.msg);
                this.$confirm("登录失败！原因：" + response.data.msg, "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {})
                  .catch(() => {});
              }
            })
            .catch((error) => {
              console.error("初始请求失败:", error);
              this.$confirm("登录失败！请检查账号密码是否正确。", "提示", {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              })
                .then(() => {
                  // 重新导航到首页
                  localStorage.clear();
                  this.$root.removeCookies();
                  this.$router.push({ path: "/login" });
                  location.reload();
                })
                .catch(() => {});
            });
        } else {
          location.reload();
          return false;
        }
      });
    },
    // getUserInfo() {
    //   const url = this.$root.commonPreUrl + "/index/getUserInfo";
    //   const token = Cookies.get("view_userToken");
    //   const res = axios.get(url, {
    //     headers: {
    //       Authorization: "Bearer " + token,
    //     },
    //   });
    //   res
    //     .then((response) => {
    //       const resd = response.data;
    //       if (resd.code == "200") {
    //         // const userName = resd.data.name;
    //         // Cookies.set('userName', userName, { expires: 1 });
    //         const userType = resd.data.user_type;
    //         if (userType == 3 || userType == "3") {
    //           Cookies.set("view_userType", "admin", { expires: 1 });
    //         } else if (userType == 2 || userType == "2") {
    //           Cookies.set("view_userType", "sub", { expires: 1 });
    //         }
    //       }
    //       setTimeout(() => {
    //         return;
    //       }, 1.5 * 1000);
    //     })
    //     .catch((error) => {
    //       console.error("初始请求失败:", error);
    // if (
    //   JSON.stringify(error).includes("Error: Request failed with status code 401")
    // ) {
    //   this.$confirm("请先导入收货地址信息再生成单号!", "提示", {
    //     confirmButtonText: "确认",
    //     showCancelButton: false, //是否显示取消按钮
    //   })
    //     .then(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {});
    // }
    //
    //       return;
    //     });
    // },
    sendCode() {
      if (this.countdown > 0) {
        return;
      }
      let phoneNum = this.phoneForm.phone;
      if (phoneNum == "" || phoneNum == null) {
        // alert("请输入手机号！");
        this.$confirm("请输入手机号！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => {});
        return;
      }
      // const url = this.$root.commonPreUrl + "/sendCode";
      const url = this.$root.commonPreUrl + "/sendVerificationCode";
      const res = axios.get(url, {
        params: { phone: phoneNum },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 设置倒计时时间，这里设置为60秒
            this.countdown = 60;
            // 创建倒计时
            const intervalId = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown -= 1;
              } else {
                clearInterval(intervalId);
              }
            }, 1000);
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
              // 重新导航到首页
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
            })
            .catch(() => {});
          return;
        });
    },
    toRegister() {
      this.$router.push({ path: "/register" });
    },
  },
};
</script>
<style scoped>
.main {
  width: 100%;
  height: 100vh;
  /* background-color: #eaebf3; */
  /* background-image: url("dlbj_image"); */
  font-weight: bold;

  /*背景布局 按轴方向*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loginBox {
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  border-radius: 1em;
  width: 430px;
  height: 415px;
  padding: 20px 40px;
}
.box_head {
  /* padding-top: 10px; */
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  height: 70px;
}
.tabBoxSwitch .tabBoxSwitchUl {
  list-style: none;
  padding: 0;
  margin: 0;
}
.tabBoxSwitch .tabBoxSwitchUl li {
  display: inline-block;
  height: 30px;
  font-size: 16px;
  line-height: 60px;
  margin-right: 24px;
  cursor: pointer;
}
/* tabs标签选中后样式 */
.selected {
  color: #0850fc;
  font-weight: 550;
  position: relative;
}
.selected::before {
  content: "";
  position: absolute;
  bottom: -15px;
  width: 100%;
  left: 0;
  border-bottom: 3px solid #0850fc;
}
.form {
  margin-top: 30px;
}
.form ul {
  margin: 0;
  padding: 0;
}
.form ul li {
  display: flex;
  flex-direction: column; /*垂直布局*/
}
.el-button {
  width: 100%;
  /* height: 100%; */
}
.el-input {
  position: relative;
}
.form a {
  position: absolute;
  text-decoration: none;
  right: 10px;
  color: #a9a9a9;
  border-left: 1px solid #ccc;
  align-items: center;
  padding-left: 10px;
}
.image {
  height: 60%;
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue